<template>
    <div class="mt-1">
      <ValidationProvider v-if="condition"  :vid="validation_label" :name="validation_label" rules="" v-slot="{ errors }">
        <div class="upload-btn-wrapper">
          <button v-bind:class="{ btn_success: file || !errors[0], btn_danger: !file  && !!errors[0]  }" class="">Upload a file</button>
          <input accept=".doc, .jpg, .pdf, .jpeg, .png, .docx, .txt"  @change="fileUploader($event)" type="file" name="myfile" />
        </div>
      </ValidationProvider>
    </div>
</template>

<script>
  const SupplierRepository = RepositoryFactory.get('supplier');
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
      name: "multi-file-uploader",
      props: {
        file: String,
        condition: {
          type: Boolean,
          default: null
        },
        required :{
          type: Boolean,
          default: true
        },
      },
    data() {
      return {
        validation_label: (Math.floor(Math.random() * 999999) + 1) + ' '
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      getRules: function () {
        return ''
      }
    },
      methods: {
        async fileUploader(event){
          this.$vs.loading();
          try {
            const file = await event.target.files[0]
            let formData = new FormData();
            formData.append('file', file);
            const file_name =  (await SupplierRepository.uploadFile(formData)).data.data.file
            this.file= file_name
            this.$emit('onSetFileName', file_name)
          } catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

      }
  }
</script>

<style scoped>

</style>
